import { loading } from '@/common/loading'
import { getDailyTask, getTaskNameList} from '@/api/baseMsg'
import { Toast } from "vant";
import previewPDF from "@/components/previewPDF/index";
import config from '@/config/index'
import axios from "axios";
export default {
  name: "examine",
  components:{
    previewPDF
  },
  data() {
    return {
      option: [],
      List: [],
      query: {
        taskCode: '',
        taskName: '',
        exeno: ''
      },
      dropdownTitle: "", //下拉展示标题
      dropdownInput: "", //搜索筛选框
      inputTable: [], //新数组作为筛选存储数组
      showDrop: false, //展示drop标记
      tableList: []
    }
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    // 获取任务列表
    getTaskNameList() {
      getTaskNameList({ taskCode: "", taskName: "", ordercol: "" }).then(
        (res) => {
          this.tableList = res;
          this.inputTable = res;
        }
      );
    },
    fuzzyQuery(keyWord) {
      //搜索筛选方法
      if (keyWord.length == 0) {
        this.inputTable = this.tableList;
        return;
      }
      const arr = [];
      for (let i = 0; i < this.tableList.length; i++) {
        if (this.tableList[i].taskName.indexOf(keyWord) >= 0) {
          arr.push(this.tableList[i]);
        }
      }
      this.inputTable = arr;
    },
    hideTabs() {
      //隐藏展示滚动tabs
      this.fuzzyQuery(this.dropdownInput);
      this.showDrop = true;
    },
    showTabs() {
      //展示滚动tabs
      this.showDrop = false;
    },
    dropClick(code, name) {
      //选择下拉列表点击事件
      this.dropdownInput = name;
      this.showDrop = !this.showDrop;
      // this.$refs.drop.toggle();
      this.query.taskCode = code;
      this.handQuery()
    },
    init() {
      loading(true);
      this.getTaskNameList()
      this.handQuery()
    },
    handQuery() {
      const params = {
        taskCode: this.query.taskCode,
        taskName: this.query.taskName,
        exeno: '',
      }
      getDailyTask(params).then(res=> {
        if(res.code == 200) {
          this.List = res.data
        }
        loading(false);
      })
      
    },
    handFill(item) {
      loading(true)
      preDownloadPdfFile({reportId: item.id}).then(res=> {
        if(res.code == 200) {
          axios({
              url: config.devProxy +
              `/ythyw/monitorReportUrls/downloadPdfFile?reportId=${item.id}`, //接口地址
              method: "post",
              responseType: "blob",
            }).then((res) => {
              const blob = new Blob([res.data])
              this.pdfParams.data = '/pdfjs/web/viewer.html?file=' + window.URL.createObjectURL(blob)
              loading(false)
              this.pdfParams.showPdf = true
          }).catch((res)=> {
            loading(false)
            Toast.fail("文件出错!")
            return
          })
        }else {
            loading(false)
            Toast.fail(res.message)
        }
      })
      
    },
    onClickLeft () {
        this.$router.push('/');
    },
    getpdfShow(data) {
        this.pdfParams.showPdf = data;
    },
    handleDateChange(val) {
      this.date.type = val
      if(this.date.type == 1) {
        this.date.currentDate = this.date.startDate ? new Date(this.date.startDate) : new Date()
      }else {
        this.date.currentDate = this.date.endDate ? new Date(this.date.endDate) : new Date()
      }
      this.date.visible = true
    },
    confirm() {
      if(this.date.type == 1) {
        this.date.startDate =  this.formatter(this.date.currentDate)
      }else {
        this.date.endDate =  this.formatter(this.date.currentDate)
      }
      this.date.visible = false
    },
    cancel() {
      this.date.visible = false
    },
    formatter(time) {
      let nowdata =time == null ?  new Date() : new Date(time);
      let year = nowdata.getFullYear();
      let month = nowdata.getMonth() + 1;
      let date = nowdata.getDate();
      let nowtime = year + "-";
      if (month < 10) {
        nowtime += "0";
      }
      nowtime += month + "-";
      if (date < 10) {
        nowtime += "0";
      }
      nowtime += date;

      return nowtime;
    },
    handClear(val) {
      if(val == 1) {
        this.date.startDate =  ''
      }else {
        this.date.endDate =  ''
      }
    }
  }
} 